module.exports = __webpack_public_path__ + "media/images/demo/cart1-1292d4b5659c961d33c981c408ea16e2.png";